import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.67 15.83 3.33 20l16.07 8.04c.22.1.33.16.45.18a.83.83 0 0 0 .3 0c.12-.02.23-.08.45-.18L36.67 20l-8.34-4.17m-16.66 8.34-8.34 4.16 16.07 8.04c.22.1.33.16.45.18a.84.84 0 0 0 .3 0c.12-.02.23-.07.45-.18l16.07-8.04-8.34-4.16m-25-12.5L19.4 3.63c.22-.1.33-.16.45-.18a.83.83 0 0 1 .3 0c.12.02.23.07.45.18l16.07 8.04L20.6 19.7c-.22.11-.33.17-.45.19a.84.84 0 0 1-.3 0c-.12-.02-.23-.08-.45-.19L3.33 11.67Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }